import { observer } from 'mobx-react-lite';
import { FrPage } from '../../fr-page-layout/fr-page';
import { FrAssignedEventPageBody } from './fr-assigned-event-page-body';
import { FrEventPageHeader } from '../../fr-event-common-components/fr-event-page-header';
import { FREventPageFooter } from '../../fr-event-common-components/fr-event-page-footer';

export const FrAssignedEventPageContent = observer(function FrAssignedEventPageContent() {
    return (
        <FrPage>
            <FrEventPageHeader />
            <FrAssignedEventPageBody />
            <FREventPageFooter />
        </FrPage>
    );
});
